export default __webpack_public_path__ + "static/media/icons8-plus.fb2878e5.svg";